module.exports = __webpack_public_path__ + "img/logo-responsive.e6ca23f0.png";